/**
 * localStorage.js stores data from setup.php when a user visits 
 * a local site for use on the national site
 */
if( typeof Storage !== "undefined" ) {

  // Do not set items if local site url contains the following strings
  if( 
    !localDogtopia.site_url.includes( "landing" ) &&
    !localDogtopia.site_url.includes( "promo" ) &&
    !localDogtopia.site_url.includes( "franchise" ) 
  ) {
    localStorage.setItem( "lastDogtopiaID", localDogtopia.site_id );
    localStorage.setItem( "lastDogtopiaName", localDogtopia.site_name );
    localStorage.setItem( "lastDogtopiaURL", localDogtopia.site_url );
  }  
}
